var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.hidenav!='hidenav')?_c('headmain'):_vm._e(),_c('router-view'),(_vm.$route.meta.hidenav!='hidenav')?_c('footmain'):_vm._e(),(_vm.$route.meta.hidenav!='hidenav')?_c('totop'):_vm._e(),_c('im')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }